import React from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { useEffect } from 'react';

function GoogleMapComponent(props){

  useEffect(() => {                
  },[]);  

  const handleCenterChanged = (mapProps, map, clickEvent) => {
    if (map) {
      props.setlocationLatitude(map.center.lat())
      props.setlocationLongitude(map.center.lng())
    }
  };
 
  const drawMarker = () => {
    
    return props.coordenadas.map((store, i) => {
      return <Marker key={i} id={i} position={{
       lat: store.lat,
       lng: store.long
     }}

     onClick={() => console.log("Event Hanlder Called")} />
    })
  }

  const mapStyle = [
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }],
    }
    ]

  function _mapLoaded(mapProps, map) {
    map.setOptions({
       styles: mapStyle
    })
 }

  return (

    <>

    <Map 
      onCenterChanged={(mapProps, map, clickEvent) => handleCenterChanged(mapProps, map, clickEvent)}            
      onReady={(mapProps, map) => _mapLoaded(mapProps, map)}
      google={props.google}      
      style={{
        width: '100%',
        height: '90%',
      }}      
      options={{ styles: [{ elementType: "labels", featureType: "poi.business", stylers: [{ visibility: "off", }], }], }}
      zoom={16}
      mapType={props.defaultView}      
      center={{
        lat: props.coordenadas[0].lat, 
        lng: props.coordenadas[0].long
        }}>          
      {drawMarker()}
    </Map>

    </>
  );

}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAKzBBmfUcgXRb4q_uUmLtZDUS9aedgsX4'
})(GoogleMapComponent);